import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/AgroMap.vue"),
  },
  {
    path: "/map",
    name: "map",
    component: () => import("../views/AgroMap.vue"),
  },
  {
    path: "/categories",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "categories",
        component: () => import("../views/Categories/CategoriesList.vue"),
        children: [
          {
            path: ":id",
            name: "categories-item",
            props: true,
            component: () => import("../views/Categories/CategoriesItem.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/objects",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "objects",
        component: () => import("../views/Objects/ObjectsList.vue"),
        children: [
          {
            path: ":id",
            name: "objects-item",
            props: true,
            component: () => import("../views/Objects/ObjectsItem.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/regions",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "regions",
        component: () => import("../views/Regions/RegionsList.vue"),
      },
      {
        path: ":id",
        name: "regions-item",
        props: true,
        component: () => import("../views/Regions/RegionsItem.vue"),
      },
    ],
  },
  {
    path: "/region-attributes",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "region-attributes",
        component: () => import("../views/Regions/RegionAttributesList.vue"),
      },
    ],
  },
  {
    path: "/region-attribute-values",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "region-attribute-values",
        component: () =>
          import("../views/Regions/RegionAttributeValuesList.vue"),
      },
    ],
  },
  {
    path: "/region-attribute-values-table",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "region-attribute-values-table",
        component: () =>
          import("../views/Regions/RegionAttributeValuesTableList.vue"),
      },
    ],
  },
  {
    path: "/region-attributes-matrix",
    component: () => import("../components/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "region-attributes-matrix",
        component: () =>
          import("../views/Regions/RegionAttributesMatrixList.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
